import { PRIVACY_URL, TERMS_URL } from "constants/legal";
import type { ConsentDisclosure as ConsentDisclosureText } from "helpers/consent-disclosure";

const LINK_CLASS = "text-soil underline";

/** The disclosure text with Terms and Privacy Policy as links. */
export default function ConsentDisclosure({
  disclosure,
}: {
  disclosure: ConsentDisclosureText;
}) {
  return (
    <>
      {disclosure.lead}
      <a
        href={TERMS_URL}
        target="_blank"
        rel="noreferrer"
        className={LINK_CLASS}
      >
        Terms
      </a>{" "}
      and{" "}
      <a
        href={PRIVACY_URL}
        target="_blank"
        rel="noreferrer"
        className={LINK_CLASS}
      >
        Privacy Policy
      </a>
      {disclosure.tail}
    </>
  );
}
